module.exports = __webpack_public_path__ + "img/promocode.70a1d2cc.png";